import { AgencyRegister } from "../types/registerTypes";
import { axiosInstance } from "../utils/axiosInstance";

const RegisterAPI = {
  Register: (agent: AgencyRegister|undefined) => {    
    const request: AgencyRegister = {
      CompanyName: agent?.CompanyName??"",
      CompanyCity: agent?.CompanyCity??"",
      CompanyAddress: agent?.CompanyAddress??"",
      CompanyPostal: agent?.CompanyPostal??"",
      AgentForename: agent?.AgentForename??"",
      AgentSurname: agent?.AgentSurname??"",
      AgentEmail:agent?.AgentEmail??"",
      AgentPhone: agent?.AgentPhone??"",
      CruiselineForename: agent?.CruiselineForename??"",
      CruiselineSurname: agent?.CruiselineSurname??"",
      CruiselineEmail: agent?.CruiselineEmail??"",
    };
    return axiosInstance.post<any>(
      `Visit/RegisterVisitAgent`, request
    );
  },
};

export default RegisterAPI;
